<template>
	<div :class="{'pl-4': cache.categories[categoryId] && cache.categories[categoryId].parent}">
		<div class="clearfix">

			<div class="pull-left" v-if="childCategories.length && cache.categories[categoryId]">
				<button type="button"
					class="btn btn-small btn-link btn-icon"
					@click.prevent="expanded = !expanded">
					<i :class="'fa-fw fa fa-chevron-' + (expanded ? 'down' : 'right') + ' text-muted'"></i>
				</button>
			</div>
			<div class="my-1 mx-3 pull-left" v-if="!childCategories.length && cache.categories[categoryId]"></div>

			<div class="pull-left p-1 my-2" v-if="cache.categories[categoryId]">
				<span class="text-primary">{{ cache.categories[categoryId].name }}</span>
			</div>

			<div class="pull-right" v-if="cache.categories[categoryId]">
				<router-link :to="'/moderate/category/' + categoryId + '/edit'" class="btn btn-small btn-warning btn-icon edit"><i class="fa fa-edit"></i></router-link>
				<button type="button" @click="remove(categoryId)" class="btn btn-small btn-danger btn-icon remove"><i class="fa fa-remove"></i></button>
			</div>

		</div>
		<template v-for="category in childCategories" v-if="expanded">
			<category-tree :category-id="category.id"></category-tree>
		</template>
	</div>
</template>

<script>
var cache = require('../base/category/category-cache');
var selfComponent = module.exports = {
	name: 'category-tree',
	props: ['categoryId'],
	data: () => ({
		cache: cache.data,
		expanded: true
	}),
	computed: {
		childCategories () {
			let children = [];
			for (let childCategoryId in this.cache.categories) {
				let childCategory = this.cache.categories[childCategoryId];
				if (childCategory.parent === this.categoryId || (!childCategory.parent && !this.categoryId)) {
					children.push(childCategory);
				}
			}
			return children;
		}
	},
	created () {
		cache.prepare(this);
	},
	methods: {
		remove: function (id) {
			this.$http.delete('backend://category/' + id).then((result) => {
				cache.update(this);
			}).catch(this.$http.toastCatcher);
		}
	},
	components: {
		'category-tree': selfComponent
	}
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// CategoryTree.vue?62b2e898